import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EBillProviderForm from "./EBillProviderComponents/EBillProviderForm";
import { useAddEBillProviderMutation } from "store/services/eBillProviderApi";

const EBillProviderCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "eBill Providers", path: "/app/crm/ebill-provider/list" },
    { title: "New Provider" },
  ];

  const [addEBillProvider, { isLoading }] = useAddEBillProviderMutation();

  const handleCreateEBillProvider = async (data) => {
    try {
      const { _id } = await addEBillProvider(data).unwrap();
      toast.success("eBill Provider successfully created!");
      navigate(`/app/crm/ebill-provider/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create eBill Provider!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <EBillProviderForm
          isBusy={isLoading}
          onSubmit={handleCreateEBillProvider}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default EBillProviderCreateScreen;